module.exports = __webpack_public_path__ + "static/media/welcome.a6170a52.gif";